module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_about-f8708134d79b3c0aa723284b2ddb7c49.jpg";